import React, { useState } from "react";
import App from "./src/App";
import "react-native-gesture-handler";
import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import SettingsRoute from "./src/Routes/SettingsRoute";
import AboutLoriiniAppRoute from "./src/Routes/AboutLoriiniAppRoute";
import EditProfilePageRoute from "./src/Routes/EditProfilePageRoute";
import ColorsRoute from "./src/Routes/ColorsRoute";
import routes from "./src/routing/routes";
import ModalTest from "./src/Routes/ModalTest";
import ModalContact from "./src/Routes/ModalContact";
import ModalContactThankYou from "./src/Routes/ModalContactThankYou";
import { useSelector } from "react-redux";
import Home from "./src/Routes/MainPage";
import RegistrationFormRoute from "./src/Routes/RegistrationFormRoute";
import ForgotPasswordRoute from "./src/Routes/ForgotPasswordRoute";
import SignInRoute from "./src/Routes/SignInRoute";
import SendMessageReset from "./src/Routes/SendMessageReset";
import AgreementRoute from "./src/Routes/AgreementRoute";
import PrivacyRoute from "./src/Routes/PrivacyRoute";
import CookiesRoute from "./src/Routes/CookiesRoute";
import { connect } from "react-redux";
import SignOutRoute from "./src/Routes/SignOutRoute";
import DeleteAccountPage from "./src/Routes/DeleteAccountPage";
import BlueAboutColorsPageRoute from "./src/Routes/BlueAboutColorsPageRoute";
import RedAboutColorsPageRoute from "./src/Routes/RedAboutColorsPageRoute";
import YellowAboutColorsPageRoute from "./src/Routes/YellowAboutColorsPageRoute";
import GreenAboutColorsPageRoute from "./src/Routes/GreenAboutColorsPageRoute";
import KnowladgeColorTheoryRoute from "./src/Routes/KnowladgeColorTheoryRoute";
import KnowladgeWhatIsLoriiniTestRoute from "./src/Routes/KnowladgeWhatIsLoriiniTestRoute";
import KnowladgeHowInterprateResultRoute from "./src/Routes/KnowladgeRouteHowInterprateResult";

import KnowladgeWaysOfCommunicationRoute from "./src/Routes/KnowladgeWaysOfCommunicationRoute";
import KnowladgeManipulationRoute from "./src/Routes/KnowladgeManipulationRoute";
import KnowladgeEffectiveCommunicationRoute from "./src/Routes/KnowladgeEffectiveCommunicationRoute";
import ApplicationLanguageRoute from "./src/Routes/ApplicationLanguageRoute";

const Stack = createStackNavigator();
const RootStack = createStackNavigator();

function title() {
  const activeFotterMenu = useSelector((state) => state.activeFotterMenu);
  switch (activeFotterMenu) {
    case 0:
      return "Loriini Tribes";
    case 1:
      return "Mój kolor";
    case 2:
      return "Kolory";
    case 3:
      return "Baza Wiedzy";
  }
}

const stylesForOptions = {
  cardStyle: {
    backgroundColor: "white",
  },
};
function MainStackScreen(props) {
  return (
    <Stack.Navigator
      screenOptions={
        {
          // header: ({ navigation, route })=><Header navigation={navigation} route={route} />,
        }
      }
      initialRouteName={routes.Start}
    >
      <Stack.Screen
        name={routes.Start}
        options={{
          headerShown: false,
          headerStyle: {
            backgroundColor: "#1672fb",
          },
          headerTintColor: "#fff",
          headerTitleStyle: {
            fontWeight: "bold",
          },
          ...stylesForOptions,
        }}
        component={App}
      />

      <Stack.Screen
        name={routes.Home}
        options={{
          title: `${title()}`,
          headerShown: false, // value - true = headearShown is displayed above | value - false = headerShown not displayed
          headerStyle: {
            backgroundColor: "#fff",
          },
          headerTintColor: "#000",
          headerTitleStyle: {},
          ...stylesForOptions,
        }}
        component={Home}
      />

      <Stack.Screen
        name={routes.RegistrationForm}
        component={RegistrationFormRoute}
        options={{ title: "", ...stylesForOptions, headerShown: false }}
      />

      <Stack.Screen
        name={routes.Agreement}
        component={AgreementRoute}
        options={{
          title: "Regulamin Aplikacji",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.KnowladgeColorTheory}
        component={KnowladgeColorTheoryRoute}
        options={{
          title: "Teoria kolorów",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.KnowladgeWhatIsLoriiniTest}
        component={KnowladgeWhatIsLoriiniTestRoute}
        options={{
          title: "Czym jest Test Loriini",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.KnowladgeHowInterprateResult}
        component={KnowladgeHowInterprateResultRoute}
        options={{
          title: "Jak interpretować wynik testu",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.KnowladgeEffectiveCommunication}
        component={KnowladgeEffectiveCommunicationRoute}
        options={{
          title: "O skutecznej komunikacji",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.KnowladgeManipulation}
        component={KnowladgeManipulationRoute}
        options={{
          title: "Czym jest manipulacja",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.KnowladgeWaysOfCommunication}
        component={KnowladgeWaysOfCommunicationRoute}
        options={{
          title: "Rodzaje komunikacji",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.Privacy}
        component={PrivacyRoute}
        options={{
          title: "Polityka Prywatności",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.Cookies}
        component={CookiesRoute}
        options={{ title: "Ciasteczka :)", ...stylesForOptions }}
      />

      <Stack.Screen
        name={routes.SignIn}
        component={SignInRoute}
        options={{
          title: "",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.ForgotPassword}
        component={ForgotPasswordRoute}
        options={{ title: "", ...stylesForOptions, headerShown: false }}
      />

      <Stack.Screen
        name={routes.Colors}
        component={ColorsRoute}
        options={{ title: "Zespół", ...stylesForOptions }}
      />

      <Stack.Screen
        name={routes.Settings}
        component={SettingsRoute}
        options={{
          title: "Ustawienia",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.GreenAboutColorsPage}
        component={GreenAboutColorsPageRoute}
        options={{
          title: "O Kolorach - Zielony",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.BlueAboutColorsPage}
        component={BlueAboutColorsPageRoute}
        options={{
          title: "O Kolorach - Niebieski",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.YellowAboutColorsPage}
        component={YellowAboutColorsPageRoute}
        options={{
          title: "O Kolorach - Źółty",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.RedAboutColorsPage}
        component={RedAboutColorsPageRoute}
        options={{
          title: "O Kolorach - Czerwony",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      {/* <Stack.Screen
        name={routes.EditProfilePage}
        component={EditProfilePageRoute}
        options={{
          title: "Edytuj Profil",
          headerShown: false,
          ...stylesForOptions,
        }}
      /> */}

      <Stack.Screen
        name={routes.DeleteAccount}
        component={DeleteAccountPage}
        options={{
          title: "Usuń Konto",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.AboutLoriiniApp}
        component={AboutLoriiniAppRoute}
        options={{
          title: "O Aplikacji",
          headerShown: false,
          ...stylesForOptions,
        }}
      />
      <Stack.Screen
        name={routes.ApplicationLanguage}
        component={ApplicationLanguageRoute}
        options={{
          title: "Język aplikacji",
          headerShown: false,
          ...stylesForOptions,
        }}
      />

      <Stack.Screen
        name={routes.SignOut}
        component={SignOutRoute}
        options={{
          title: "Wylogowano",
          headerShown: false,
          ...stylesForOptions,
        }}
      />
    </Stack.Navigator>
  );
}

function RootRouter(props) {
  const [current, setCurrent] = useState(0);
  const [currentWalk, setCurrentWalk] = useState(0);
  const displayName = props.displayName;
  return (
    <NavigationContainer>
      <RootStack.Navigator mode="modal" headerMode="none">
        <RootStack.Screen
          name="Main"
          children={() => <MainStackScreen displayName={displayName} />}
        />
        <RootStack.Screen name={routes.ModalTest} component={ModalTest} />
        <RootStack.Screen
          name={routes.EditProfilePage}
          component={EditProfilePageRoute}
        />

        <RootStack.Screen
          name={routes.SendMessageReset}
          component={SendMessageReset}
        />
        <RootStack.Screen name={routes.Contact} component={ModalContact} />
        <RootStack.Screen
          name={routes.ContactThankYou}
          component={ModalContactThankYou}
        />
      </RootStack.Navigator>
    </NavigationContainer>
  );
}

const mapStateToProps = (state) => {
  const displayName = state?.user?.user?.displayName;

  return { displayName };
};
export default connect(mapStateToProps)(RootRouter);
